import Router from './index';

const push = (name, params = {}, query = {}) => Router.push({ name, params, query });
const back = async (toListPage) => {
  // 判断上一页是否是登录页（根据路由名称或路径）
  const lastRoute = Router.lastRoute;
  const isFromLogin = lastRoute && (
    lastRoute.name === config.login.name || lastRoute.path === config.login.path
  );

  // 尝试返回
  if (window.history.length < 2 || isFromLogin || !lastRoute.name) {
    toListPage();
    return;
  }

  try {
    await Router.go(-1);
  } catch (error) {
    toListPage();
  }
};

// 'administrator', 'manager', 'receptionist', 'receptionist_shift', 'consultant', 'teacher'
let config = {
  home: { label: '主页', path: '/', icon: 'home' },

  login: { label: '登录', path: '/login', hidden: true },

  studentList: { label: '学员列表', path: '/students', open: true },
  studentRankList: { label: '上课排名', path: '/students/ranks' },
  studentRankActivityList: { label: '舞者等级活动列表', path: '/student-rank-activities', open: false },
  studentRankActivityDeletedList: { label: '已删活动', path: '/student-rank-activities/deletions', role: ['administrator'] },
  studentRankActivityAdd: { label: '添加活动', path: '/student-rank-activities/add', role: ['administrator'] },
  studentRankActivityEdit: { label: '修改活动', path: '/student-rank-activities/:id(\\d+)/edit', hidden: true, role: ['administrator'] },
  studentRankActivityRankList: { label: '活动上课排名', path: '/student-rank-activities/:id(\\d+)/ranks', hidden: true },
  studentRankLevelList: { label: '等级字典', path: '/student-rank-activities/levels', role: ['administrator'] },
  studentRankLevelDeletedList: { label: '已删等级', path: '/student-rank-activities/levels/deletions', role: ['administrator'] },
  studentRankLevelAdd: { label: '添加等级', path: '/student-rank-activities/levels/add', role: ['administrator'] },
  studentRankLevelEdit: { label: '修改等级', path: '/student-rank-activities/levels/:id(\\d+)/edit', hidden: true, role: ['administrator'] },
  studentUpdateRequestList: { label: '修改申请', path: '/students/update-requests' },
  studentUpdateRecordList: { label: '个人资料修改记录', path: '/students/update-records', role: ['administrator'] },
  studentDeletedList: { label: '学员注销记录', path: '/students/deleted' },
  studentDeletionRequestList: { label: '注销申请列表', path: '/students/deletion-requests' },
  studentAdd: { label: '注册新学员', path: '/students/add' },
  studentEdit: { label: '编辑学员资料', path: '/students/:id(\\d+)', hidden: true },
  studentDetail: { label: '学员详情', path: '/students/:id(\\d+)/details', hidden: true },
  studentUpdateRecordDetail: { label: '学员修改记录详情', path: '/students/update-records/:id(\\d+)', hidden: true },
  studentDeleteDetail: { label: '学员注销详情', path: '/students/:id(\\d+)/deletion-details', hidden: true },
  studentUpdateRequestDetail: { label: '学员修改申请详情', path: '/students/update-requests/:id(\\d+)', hidden: true },
  studentDeletionRequestDetail: { label: '学员注销申请详情', path: '/students/deletion-requests/:id(\\d+)', hidden: true },

  latentStudentList: { label: '潜在学员列表', path: '/latent-students', open: false },
  latentStudentBrowseList: { label: '学员访问记录', path: '/latent-students/browses' },
  latentStudentTrailList: { label: '学员试课记录', path: '/latent-students/trials' },

  cardList: { label: '课卡列表', path: '/cards', open: true },
  cardAddApplyList: { label: '办卡申请', path: '/cards/add-applies' },
  cardDeletedList: { label: '退卡记录', path: '/cards/delete-records' },
  cardDeleteApplyList: { label: '退卡申请', path: '/cards/delete-applies' },
  cardUpdateRecordList: { label: '修改记录', path: '/cards/update-records' },
  cardUpdateApplyList: { label: '修改申请', path: '/cards/update-applies' },
  cardEditDateBatch: { label: '停课延期', path: '/cards/edit-dates', role: ['administrator'] },
  cardAdd: { label: '办理课卡', path: '/cards/add' },

  cardDeleteApplyDetail: { label: '退卡申请详情', path: '/cards/delete-applies/:id(\\d+)', hidden: true },
  cardDeleteRecordDetail: { label: '退卡详情', path: '/cards/delete-records/:id(\\d+)', hidden: true },
  cardDeleteRecordEdit: { label: '修改退卡原因', path: '/cards/delete-records/:id(\\d+)/edit', hidden: true },
  cardDetail: { label: '课卡详情', path: '/cards/:id(\\d+)', hidden: true },
  cardEdit: { label: '修改课卡信息', path: '/cards/:id(\\d+)/edit', hidden: true },
  cardEditDate: { label: '修改课卡日期', path: '/cards/:id(\\d+)/edit-date', hidden: true },
  cardEditNumber: { label: '修改课卡次数', path: '/cards/:id(\\d+)/edit-number', hidden: true },
  cardEditType: { label: '修改课卡类型', path: '/cards/:id(\\d+)/edit-type', hidden: true },
  cardAddApplyDetail: { label: '办卡申请详情', path: '/cards/add-applies/:id(\\d+)', hidden: true },
  cardAddApplyEdit: { label: '修改办卡申请', path: '/cards/add-applies/:id(\\d+)/edit', hidden: true },
  cardUpdateApplyDetail: { label: '课卡修改申请详情', path: '/cards/update-applies/:id(\\d+)', hidden: true },
  cardUpdateRecordDetail: { label: '课卡修改详情', path: '/cards/update-records/:id(\\d+)', hidden: true },
  cardDelete: { label: '退卡', path: '/cards/:id(\\d+)/delete', hidden: true },

  cardChargeTypeList: { label: '课卡套餐列表', path: '/card-charge-types', open: false, role: ['administrator'] },
  cardChargeTypeDeletedList: { label: '已删套餐', path: '/card-charge-types/deletions' },
  cardChargeTypeAdd: { label: '添加套餐', path: '/card-charge-types/add' },
  cardChargeTypeEdit: { label: '修改课卡套餐', path: '/card-charge-types/:id(\\d+)', hidden: true },
  cardChargeTypeYearlyAnalysis: { label: '年卡使用分析', path: '/card-charge-types/yearly-analysis', role: ['administrator'] },

  cardTicketList: { label: '课次券列表', path: '/card-tickets', open: false },
  cardTicketDeletedList: { label: '已退课次券', path: '/card-tickets/deletions', role: ['administrator'] },
  cardTicketUpdateRecordList: { label: '修改记录', path: '/card-tickets/update-records', role: ['administrator'] },
  cardTicketAdd: { label: '添加课次券', path: '/card-tickets/add' },
  cardTicketAddApplyList: { label: '办券申请列表', path: '/card-tickets/add-applies', open: false },
  cardTicketAddApplyDetail: { label: '课卡添加申请详情', path: '/card-tickets/add-applies/:id(\\d+)', hidden: true },
  cardTicketDetail: { label: '课次券详情', path: '/card-tickets/:id(\\d+)', hidden: true },
  cardTicketEditDate: { label: '修改过期时间', path: '/card-tickets/:id(\\d+)/edit-date', role: ['administrator'], hidden: true },
  cardTicketEditNumber: { label: '修改剩余次数', path: '/card-tickets/:id(\\d+)/edit-number', role: ['administrator'], hidden: true },
  cardTicketDelete: { label: '退券', path: '/card-tickets/:id(\\d+)/delete', role: ['administrator'], hidden: true },
  cardTicketDeleteRecordDetail: { label: '退券详情', path: '/card-tickets/delete-records/:id(\\d+)', role: ['administrator'], hidden: true },

  cardTicketTypeList: { label: '课次券类型列表', path: '/card-ticket-types', open: false, role: ['administrator'] },
  cardTicketTypeDeletedList: { label: '已删类型', path: '/card-ticket-types/deletions' },
  cardTicketTypeAdd: { label: '添加类型', path: '/card-ticket-types/add' },
  cardTicketTypeEdit: { label: '修改课次券类型', path: '/card-ticket-types/:id(\\d+)', hidden: true },

  voucherTypeList: { label: '代金券类型列表', path: '/voucher-types', open: false, role: ['administrator'] },
  voucherTypeDeletedList: { label: '已删类型', path: '/voucher-types/deletions' },
  voucherTypeAdd: { label: '添加类型', path: '/voucher-types/add' },
  voucherTypeEdit: { label: '修改代金券类型', path: '/voucher-types/:id(\\d+)', hidden: true },

  voucherList: { label: '代金券列表', path: '/vouchers', open: false },
  voucherDeletedList: { label: '已退代金券', path: '/vouchers/deletions' },
  voucherAdd: { label: '办理代金券', path: '/vouchers/add' },
  voucherAddApplyList: { label: '办券申请列表', path: '/vouchers/add-applies', open: false },
  voucherAddApplyDetail: { label: '代金券申请详情', path: '/vouchers/add-applies/:id(\\d+)', hidden: true },
  voucherDetail: { label: '代金券详情', path: '/vouchers/:id(\\d+)', hidden: true },
  voucherDelete: { label: '退券', path: '/vouchers/:id(\\d+)/delete', role: ['administrator'], hidden: true },

  courseList: { label: '课程列表', path: '/courses', open: true, role: ['administrator', 'manager', 'receptionist', 'receptionist_shift', 'consultant', 'staff'] },
  courseTodayList: { label: '今日课程', path: '/courses/today' },
  courseDeletedList: { label: '已删课程', path: '/courses/deletions' },
  courseReservationRecordList: { label: '课程预约记录', path: '/courses/reservation-records', role: ['administrator'] },
  courseAdd: { label: '添加课程', path: '/courses/add' },
  courseEdit: { label: '修改课程', path: '/courses/:id(\\d+)/edit', hidden: true },
  courseReserve: { label: '签到课程', path: '/courses/:id(\\d+)/sign', hidden: true },
  courseTrial: { label: '添加试课', path: '/courses/:id(\\d+)/trail', hidden: true },
  courseManage: { label: '管理课程', path: '/courses/:id(\\d+)/manage', hidden: true },

  courseScheduleList: { label: '课表列表', path: '/course-schedules', open: false },
  courseScheduleDeletedList: { label: '已删课表', path: '/course-schedules/deletions' },
  courseScheduleAdd: { label: '添加课表', path: '/course-schedules/add' },
  courseScheduleEdit: { label: '修改课表', path: '/course-schedules/:id(\\d+)/edit', hidden: true },

  courseColumnList: { label: '课程专栏列表', path: '/course-columns', open: false },
  courseColumnDeletedList: { label: '已删专栏', path: '/course-columns/deletions' },
  courseColumnAdd: { label: '添加专栏', path: '/course-columns/add' },
  courseColumnEdit: { label: '修改专栏', path: '/course-columns/:id(\\d+)', hidden: true },
  courseColumnManage: { label: '课程专栏预约管理', path: '/course-columns/:id(\\d+)/manage', hidden: true },

  courseTagList: { label: '课程标签列表', path: '/course-tags', open: false, role: ['administrator'] },
  courseTagDeletedList: { label: '已删标签', path: '/course-tags/deletions' },
  courseTagAdd: { label: '添加标签', path: '/course-tags/add' },
  courseTagEdit: { label: '修改标签', path: '/course-tags/:id(\\d+)', hidden: true },

  courseStyleList: { label: '课程舞蹈风格列表', path: '/course-styles', open: false },
  courseStyleDeletedList: { label: '已删风格', path: '/course-styles/deletions' },
  courseStyleAddApplyList: { label: '风格申请', path: '/course-styles/add-requests' },
  courseStyleAdd: { label: '添加风格', path: '/course-styles/add' },
  courseStyleAddApplyDetail: { label: '课程舞蹈风格申请详情', path: '/course-styles/add-requests/:id(\\d+)', hidden: true },
  courseStyleEdit: { label: '修改课程舞蹈风格', path: '/course-styles/:id(\\d+)', hidden: true },

  courseDifficultyList: { label: '课程难度列表', path: '/course-difficulties', open: false },
  courseDifficultyDeletedList: { label: '已删难度', path: '/course-difficulties/deletions' },
  courseDifficultyAddApplyList: { label: '难度申请', path: '/course-difficulties/add-requests' },
  courseDifficultyAdd: { label: '添加难度', path: '/course-difficulties/add' },
  courseDifficultyAddApplyDetail: { label: '课程难度申请详情', path: '/course-difficulties/add-requests/:id(\\d+)', hidden: true },
  courseDifficultyEdit: { label: '修改课程难度', path: '/course-difficulties/:id(\\d+)', hidden: true },

  courseTipList: { label: '课程注意事项列表', path: '/course-tips', open: false, role: ['administrator'] },
  courseTipDeletedList: { label: '已删注意事项', path: '/course-tips/deletions' },
  courseTipAdd: { label: '添加注意事项', path: '/course-tips/add' },
  courseTipEdit: { label: '修改注意事项', path: '/course-tips/:id(\\d+)/edit', hidden: true },

  courseWhitelistList: { label: '课程白名单列表', path: '/course-whitelists', open: false },
  courseWhitelistDeletedList: { label: '已删白名单列表', path: '/course-whitelists/deletions' },
  courseWhitelistAdd: { label: '添加白名单', path: '/course-whitelists/add' },
  courseWhitelistManage: { label: '白名单管理', path: '/course-whitelists/:id(\\d+)/manage', hidden: true },

  courseCoverList: { label: '课程封面列表', path: '/course-covers', open: false, role: ['administrator'] },
  courseCoverDeletedList: { label: '已删封面', path: '/course-covers/deletions' },
  courseCoverAdd: { label: '添加封面', path: '/course-covers/add' },
  courseCoverEdit: { label: '修改封面', path: '/course-covers/:id(\\d+)', hidden: true },

  courseVideoList: { label: '封面视频列表', path: '/course-videos', open: false, role: ['administrator'] },
  courseVideoDeletedList: { label: '已删视频', path: '/course-videos/deletions' },
  courseVideoAdd: { label: '添加视频', path: '/course-videos/add' },
  courseVideoEdit: { label: '修改视频', path: '/course-videos/:id(\\d+)', hidden: true },

  teacherList: { label: '老师列表', path: '/teachers', open: false },
  teacherDeletedList: { label: '已删老师', path: '/teachers/deletions' },
  teacherSalaryList: { label: '老师薪资列表', path: '/teachers/salaries', role: ['administrator', 'manager'] },
  teacherSalaryRecordList: { label: '老师薪资发放记录', path: '/teachers/salary-records', role: ['administrator'] },
  teacherStageNumberEdit: { label: '阶梯人数设置', path: '/teachers/stage-numbers', role: ['administrator', 'manager'] },
  teacherStageSalaryEdit: { label: '阶梯薪资设置', path: '/teachers/stage-salaries', role: ['administrator', 'manager'] },
  teacherRankList: { label: '老师上课排名', path: '/teachers/ranks' },
  teacherAddApplyList: { label: '老师添加申请', path: '/teachers/add-applies' },
  teacherAdd: { label: '添加老师', path: '/teachers/add' },
  teacherAddApplyDetail: { label: '老师添加申请详情', path: '/teachers/add-applies/:id(\\d+)', hidden: true },
  teacherEdit: { label: '修改老师资料', path: '/teachers/:id(\\d+)/edit', hidden: true },
  teacherDetail: { label: '老师详情', path: '/teachers/:id(\\d+)', hidden: true },
  teacherSalaryAdd: { label: '添加老师至门店', path: '/teachers/:id(\\d+)/salary-add', hidden: true, role: ['administrator', 'manager'] },
  teacherSalaryEdit: { label: '修改老师薪资', path: '/teachers/:id(\\d+)/salary-edit', hidden: true, role: ['administrator', 'manager'] },

  administratorList: { label: '管理员列表', path: '/administrators', open: false, role: ['administrator', 'manager'] },
  administratorDeletedList: { label: '注销记录', path: '/administrators/deletions' },
  administratorLoginRecordList: { label: '登录日志', path: '/administrators/login-records', role: ['administrator'] },
  administratorViewRecordList: { label: '浏览记录', path: '/administrators/view-records', role: ['administrator'] },
  administratorSalaryList: { label: '薪资列表', path: '/administrators/salaries' },
  administratorAdd: { label: '添加管理员', path: '/administrators/add', role: ['administrator'] },
  administratorEdit: { label: '修改管理员信息', path: '/administrators/:id(\\d+)/edit', hidden: true, role: ['administrator'] },
  administratorEditPassword: { label: '修改密码', path: '/administrators/:id(\\d+)/password-edit', hidden: true },
  administratorEditPasswordByAdministrator: { label: '修改密码', path: '/administrators/:id(\\d+)/password-edit-by-administrator', hidden: true, role: ['administrator'] },
  administratorSalaryAdd: { label: '添加管理员至门店', path: '/administrators/salaries/:id(\\d+)/add', hidden: true, role: ['administrator'] },
  administratorSalaryEdit: { label: '编辑管理员薪资', path: '/administrators/salaries/:id(\\d+)/edit', hidden: true },

  administratorProfile: { label: '个人中心', path: '/administrators/profile', hidden: true },
  administratorInviteList: { label: '入职邀请', path: '/administrators/invites', role: ['administrator', 'manager'] },
  administratorInviteDetail: { label: '入职邀请详情', path: '/administrators/invites/:id(\\d+)', hidden: true, role: ['administrator', 'manager'] },
  administratorOnboardApplyList: { label: '入职申请审核', path: '/administrators/onboard-applies', role: ['administrator', 'manager'] },
  administratorOnboardApplyDetail: { label: '入职申请详情', path: '/administrators/onboard-applies/:id(\\d+)', hidden: true, role: ['administrator', 'manager'] },
  administratorOffboardApplyList: { label: '离职申请审核', path: '/administrators/offboard-applies', role: ['administrator', 'manager'] },
  administratorOffboardApplyDetail: { label: '离职申请详情', path: '/administrators/offboard-applies/:id(\\d+)', hidden: true, role: ['administrator', 'manager'] },
  administratorOperationLogList: { label: '操作日志', path: '/administrators/operation-logs', role: ['administrator'] },
  administratorOperationLogDetail: { label: '操作日志详情', path: '/administrators/operation-logs/:id(\\d+)', hidden: true, role: ['administrator'] },
  onboard: { label: '入职申请', path: '/onboard', hidden: true },


  dailyReportList: { label: '日常总结列表', path: '/daily-reports', open: false },
  dailyReportAdd: { label: '添加总结', path: '/daily-reports/add' },
  dailyReportDetail: { label: '日常总结详情', path: '/daily-reports/:id(\\d+)', hidden: true },
  dailyReportEdit: { label: '修改日常总结', path: '/daily-reports/:id(\\d+)/edit', hidden: true },

  monthlyReportList: { label: '月度总结列表', path: '/monthly-reports', open: false, role: ['administrator', 'manager'] },
  // monthlyReportDeletedList: { label: '已删总结', path: '/monthly-reports/deletions' },
  monthlyReportRankList: { label: '门店排名', path: '/monthly-reports/ranks' },
  monthlyReportAdd: { label: '添加总结', path: '/monthly-reports/add' },
  monthlyReportEdit: { label: '修改月度总结', path: '/monthly-reports/:id(\\d+)/edit', hidden: true },
  monthlyReportDetail: { label: '月度总结详情', path: '/monthly-reports/:id(\\d+)', hidden: true },

  officeMonthlyReportList: { label: '办公室月总结列表', path: '/office-monthly-reports', open: false, role: ['administrator'] },
  officeMonthlyReportAdd: { label: '添加总结', path: '/office-monthly-reports/add' },
  officeMonthlyReportDetail: { label: '办公室月度总结详情', path: '/office-monthly-reports/:id(\\d+)', hidden: true },
  officeMonthlyReportEdit: { label: '修改办公室月度总结', path: '/office-monthly-reports/:id(\\d+)/edit', hidden: true },

  invoiceList: { label: '发票列表', path: '/invoices', open: false },
  invoiceAdd: { label: '申请发票', path: '/invoices/add' },
  invoiceDetail: { label: '发票申请详情', path: '/invoices/:id(\\d+)', hidden: true },

  invoiceClassList: { label: '发票类目列表', path: '/invoice-classes', open: false, role: ['administrator'] },
  invoiceClassDeletedList: { label: '已删类目', path: '/invoice-classes/deletions' },
  invoiceClassAdd: { label: '添加类目', path: '/invoice-classes/add' },
  invoiceClassEdit: { label: '修改发票类目', path: '/invoice-classes/:id(\\d+)/edit', hidden: true },

  videoList: { label: '视频列表', path: '/videos', open: false, role: ['administrator'] },
  videoDeletedList: { label: '已删视频', path: '/videos/deletions' },
  videoAdd: { label: '添加视频', path: '/videos/add' },
  videoEdit: { label: '修改视频', path: '/videos/:id(\\d+)', hidden: true },

  integralActivityList: { label: '积分活动列表', path: '/integral-activities', open: false },
  integralActivityDeletedList: { label: '已删活动', path: '/integral-activities/deletions', role: ['administrator'] },
  integralActivityAdd: { label: '添加活动', path: '/integral-activities/add', role: ['administrator'] },
  integralActivityEdit: { label: '修改积分活动', path: '/integral-activities/:id(\\d+)/edit', hidden: true, role: ['administrator'] },

  integralActivityTargetList: { label: '积分活动目标列表', path: '/integral-activity-targets', open: false },
  integralActivityTargetDeletedList: { label: '已删活动目标', path: '/integral-activity-targets/deletions' },
  integralActivityTargetAdd: { label: '添加活动目标', path: '/integral-activity-targets/add', role: ['administrator'] },
  integralActivityTargetEdit: { label: '修改积分活动目标', path: '/integral-activity-targets/:id(\\d+)/edit', hidden: true, role: ['administrator'] },
  integralActivityTargetEntityReceiveManage: { label: '积分活动实物奖励领取管理', path: '/integral-activity-targets/:id(\\d+)/entity-receive-manage', hidden: true },


  bannerList: { label: '轮播图列表', path: '/banners', open: false, role: ['administrator'] },
  bannerDeletedList: { label: '已删轮播图', path: '/banners/deletions' },
  bannerAdd: { label: '添加轮播图', path: '/banners/add' },
  bannerEdit: { label: '修改轮播图', path: '/banners/:id(\\d+)', hidden: true },

  storeQrCodeList: { label: '门店二维码', path: '/store-qr-codes', open: true },
  storeList: { label: '门店列表', path: '/stores', open: true, role: ['administrator'] },
  storeDeletedList: { label: '已删门店', path: '/stores/deletions' },
  storeAdd: { label: '添加门店', path: '/stores/add' },
  storeEdit: { label: '修改门店', path: '/stores/:id(\\d+)/edit', hidden: true },

  /*storeCoverList: { label: '门店封面列表', path: '/store-covers', open: false, role: ['administrator', 'manager'] },
  storeCoverDeletedList: { label: '已删轮播图', path: '/store-covers/deletions' },
  storeCoverAdd: { label: '添加轮播图', path: '/store-covers/add' },
  storeCoverEdit: { label: '修改轮播图', path: '/store-covers/:id(\\d+)', hidden: true },*/

  weChatOrderList: { label: '微信支付订单列表', path: '/we-chat-orders', open: false, role: ['administrator'] },
  weChatOrderRefundList: { label: '退款订单', path: '/we-chat-orders/refunds' },

  youZanSignDateList: { label: '有赞签到日期列表', path: '/you-zan-sign-dates', open: false, role: ['administrator'] },
  youZanSignDateDeletedList: { label: '已删日期', path: '/you-zan-sign-dates/deletions' },
  youZanSignDateVerifiedList: { label: '核销记录', path: '/you-zan-sign-dates/verified-records' },
  youZanSignDateSignedList: { label: '签到记录', path: '/you-zan-sign-dates/signed-records' },
  youZanSignDateAdd: { label: '添加日期', path: '/you-zan-sign-dates/add' },
  youZanSignDateEdit: { label: '修改日期', path: '/you-zan-sign-dates/:id(\\d+)/edit', hidden: true },

  appPageList: { label: '小程序页面列表', path: '/app-pages', open: false, role: ['administrator'] },
  appPageDeletedList: { label: '已删页面', path: '/app-pages/deletions', role: ['administrator'] },
  appPageAdd: { label: '添加页面', path: '/app-pages/add', role: ['administrator'] },
  appPageEdit: { label: '修改页面', path: '/app-pages/:id(\\d+)/edit', hidden: true, role: ['administrator'] },

  errorLogList: { label: '错误日志列表', path: '/error-logs', open: false, role: ['administrator'] },
  errorLogYouZanList: { label: '有赞日志', path: '/error-logs/you-zan' },
  errorWeChatOrderList: { label: '微信支付日志', path: '/error-logs/we-chat-orders' },
  errorWorkWeChatList: { label: '企业微信日志', path: '/error-logs/work-we-chat' },
  errorWeChatSubscribeList: { label: '小程序消息日志', path: '/error-logs/subscribe-messages' },
  errorSmsList: { label: '短信日志', path: '/error-logs/sms' },
  errorLogDetail: { label: '错误日志详情', path: '/error-logs/:id(\\d+)', hidden: true },
  errorLogYouZanDetail: { label: '有赞错误日志详情', path: '/error-logs/you-zan/:id(\\d+)', hidden: true },
  errorLogWeChatOrderDetail: { label: '微信支付错误日志详情', path: '/error-logs/we-chat-orders/:id(\\d+)', hidden: true },
  errorWorkWeChatDetail: { label: '企业微信错误日志详情', path: '/error-logs/work-we-chat/:id(\\d+)', hidden: true },

  /*
  error: 'error',
  errorUnauthorized: 'errorUnauthorized',
  errorNotFound: 'errorNotFound',
*/

};

function setRouteNames() {
  for (const key in config) {
    let value = config[key];
    if (!value.role) value.role = ['administrator', 'manager', 'receptionist', 'receptionist_shift', 'consultant'];
    value.name = `${key[0].toUpperCase()}${key.slice(1)}`;
    value.push = (idOrQuery, query) => {
      // 传数字视为路由参数 id，传对象视为 query，向后兼容
      if (typeof idOrQuery === 'number') return push(value.name, { id: idOrQuery }, query || {});
      return push(value.name, {}, idOrQuery || {});
    };
    value.back = () => back(value.push);
    value.to = (id, query) => ({ name: value.name, params: { id }, query });
  }

  return config;
}
setRouteNames();

export default config;
